import React, { useEffect, useState } from "react";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { FaSpinner } from "react-icons/fa";
import moment from "moment";
import {
  addYears,
  subDays,
  startOfMonth,
  endOfMonth,
  format,
  getDaysInMonth,
  addMonths,
} from "date-fns";
import { Table } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_URL } from "../../../../constants";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import DeleteModal from "../../../../components/DeletePopUpComponent";

const HRCalenderForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Add Calendar"));
    fetchHRCalender();
  }, []);

  const [selectedDate, setSelectedDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [holidayLineErrors, setHolidayLineErrors] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [deleteType, setDeleteType] = useState("");
  const [isAddDisabled, setIsAddDisabled] = useState(true);
  const [errors, setErrors] = useState({
    Code: false,
    Name: false,
    CompanyID: false,
    PayrollMethod: false,
    StartDate: false,
  });

  const initialFormData = {
    Code: "",
    Name: "",
    Description: "",
    CompanyID: "",
    StartDate: "",
    EndDate: "",
    PayrollMethod: "",
    WorkingDays: "",
    calendarHolidayLines: [],
    calendarMonthLines: [
      {
        MonthName: "",
        StartDate: "",
        EndDate: "",
        PayableDays: "",
      },
    ],
  };

  const [formData, setFormData] = useState(initialFormData);
  console.log('formData',formData);
  
  const [calenderData, setCalenderData] = useState([]);
  const [calendarDetails, setCalendarDetails] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [payrolMethod, setPayrolMethod] = useState([]);
  const [branchOpt, setBranchOpt] = useState([]);
  const [holidayOpt, setHolidayOpt] = useState([]);

  const fetchHRCalender = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}calendarmaster`);
      if (response.status === 200) {
        const calenderData = response?.data?.header;
        setCalenderData(calenderData || []);
      } else {
        console.error(
          "Failed to fetch Course. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Course:", error);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const errorMessages = [];

    if (!formData.Code) {
      newErrors.Code = true;
      errorMessages.push("Code is required.");
    }
    if (!formData.Name) {
      newErrors.Name = true;
      errorMessages.push("Name is required.");
    }
    if (!formData.CompanyID) {
      newErrors.CompanyID = true;
      errorMessages.push("Company is required.");
    }
    // if (!formData.WorkingDays) {
    //   newErrors.WorkingDays = true;
    //   errorMessages.push("Working Days are required.");
    // }
    if (!formData.PayrollMethod) {
      newErrors.PayrollMethod = true;
      errorMessages.push("Payroll Method is required.");
    }
    if (!formData.StartDate) {
      newErrors.StartDate = true;
      errorMessages.push("Start Date is required.");
    }

    const lineErrors = formData.calendarHolidayLines.map((line, index) => {
      const lineError = {};
      if (!line.CompanyID) {
        lineError.CompanyID = true;
        errorMessages.push(`Row ${index + 1}: Branch is required.`);
      }
      if (!line.HolidayID) {
        lineError.HolidayID = true;
        errorMessages.push(`Row ${index + 1}: Holiday is required.`);
      }
      if (!line.FromDate) {
        lineError.FromDate = true;
        errorMessages.push(`Row ${index + 1}: From Date is required.`);
      }
      return lineError;
    });

    setErrors(newErrors);
    setHolidayLineErrors(lineErrors);

    return errorMessages;
  };

  const handleStartDateChange = (date) => {
    const selectedYear = date.getFullYear();

    // check if that year already exists in calenderData
    const isYearExists = calenderData.some(
      (item) =>
        item?.StartDate &&
        new Date(item.StartDate).getFullYear() === selectedYear
    );
    if (isYearExists) {
      setSelectedDate(null);
      toast.error(`Calendar already generated for the  (${selectedYear}) Year`);
      setIsAddDisabled(true);
      return;
    }
    setSelectedDate(date);
    setErrors((prevErrors) => ({
      ...prevErrors,
      StartDate: false,
    }));
    if (date) {
      const newEndDate = subDays(addYears(date, 1), 1);
      setEndDate(newEndDate);

      const details = [];
      for (let i = 0; i < 12; i++) {
        const currentMonth = addMonths(date, i);
        const monthName = format(currentMonth, "MMMM yyyy");
        const monthStartDate = format(
          startOfMonth(currentMonth),
          "dd-MMM-yyyy"
        );
        const monthEndDate = format(endOfMonth(currentMonth), "dd-MMM-yyyy");
        const monthDays = getDaysInMonth(currentMonth);

        details.push({
          monthName,
          monthStartDate,
          monthEndDate,
          monthDays,
        });
      }

      setCalendarDetails(details);
      setFormData({
        ...formData,
        StartDate: format(date, "yyyy-MM-dd"),
        EndDate: format(newEndDate, "yyyy-MM-dd"),
        calendarMonthLines: details.map((details, index) => ({
          MonthName: details.monthName,
          StartDate: details.monthStartDate,
          EndDate: details.monthEndDate,
          PayableDays: details.monthDays,
        })),
      });
      setIsAddDisabled(false);
    } else {
      setEndDate(null);
      setCalendarDetails([]);
      setFormData({
        ...formData,
        StartDate: "",
        EndDate: "",
        calendarMonthLines: [],
      });
      setIsAddDisabled(true);
    }
  };

  const handleInputChange = (name, selectedOption) => {
    setFormData({
      ...formData,
      [name]: selectedOption.value,
    });

    // Clear error only for the specific field that changed
    if (name === "CompanyID" || name === "PayrollMethod") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: false,
      }));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "Name") {
      const inputYear = value.replace(/[^\d]/g, "");
      const isDuplicate = calenderData.some((calendar) => {
        const existingYear = calendar.Name.replace(/[^\d]/g, "");
        return existingYear === inputYear && inputYear !== "";
      });

      if (isDuplicate) {
        toast.error("Calendar for this year already exists");
        setFormData((prev) => ({ ...prev, Name: "" }));
        return;
      }
    }

    if (name === "WorkingDays") {
    if (Number(value) > 31) {
      toast.error("Fixed Payable days cannot be more than 31");
      return;
    }
  }
    setFormData({ ...formData, [name]: value });
    if (name === "Code" || name === "Name") {
      setErrors({ ...errors, [name]: false });
    }
  };

  const handleLineChange = (e, index) => {
    const { name, value } = e.target;
    const lines = [...formData.calendarHolidayLines];
    lines[index][name] = value;
    setFormData({
      ...formData,
      calendarHolidayLines: lines,
    });
  };

  const handleSelectChange = (selectedOption, name, index) => {
    const lines = [...formData.calendarHolidayLines];
    lines[index][name] = selectedOption.value;
    setFormData({
      ...formData,
      calendarHolidayLines: lines,
    });
    setHolidayLineErrors((prev) => {
      const newErrors = [...prev];
      if (!newErrors[index]) newErrors[index] = {};
      newErrors[index][name] = false;
      return newErrors;
    });
  };


const handleResDateChange = (event, index) => {
  const { name, value } = event.target;
  const updatedLines = [...formData.calendarHolidayLines];
  updatedLines[index] = {
    ...updatedLines[index],
    [name]: value,
  };

  const validateDate = (fieldName, dateValue) => {
    if (formData.StartDate && formData.EndDate && dateValue) {
      const selectedDate = new Date(dateValue);
      const startDate = new Date(formData.StartDate);
      const endDate = new Date(formData.EndDate);

      if (selectedDate < startDate || selectedDate > endDate) {
        updatedLines[index][fieldName] = "";

        toast.error(
          `Holiday ${fieldName} must be between Calendar StartDate and Calendar EndDate`,
          {
            position: "top-right",
            autoClose: 3000,
          }
        );

        setFormData((prevState) => ({
          ...prevState,
          calendarHolidayLines: updatedLines,
        }));
        return false;
      }
    }

    // Duplicate check
    const duplicateIndex = updatedLines.findIndex(
      (line, i) => i !== index && line[fieldName] === dateValue
    );

    if (duplicateIndex !== -1) {
      updatedLines[index][fieldName] = "";

      toast.error(`This ${fieldName} is already used!`, {
        position: "top-right",
        autoClose: 3000,
      });

      setFormData((prevState) => ({
        ...prevState,
        calendarHolidayLines: updatedLines,
      }));
      return false;
    }

    return true;
  };

  if (name === "FromDate" && value) {
    if (!validateDate("FromDate", value)) return;
  }

  if (name === "ToDate" && value) {
    if (!validateDate("ToDate", value)) return;
  }

  if (name === "FromDate" || name === "ToDate") {
    setHolidayLineErrors((prev) => {
      const newErrors = [...prev];
      if (!newErrors[index]) newErrors[index] = {};
      newErrors[index][name] = false;
      return newErrors;
    });
  }

  setFormData((prevState) => ({
    ...prevState,
    calendarHolidayLines: updatedLines,
  }));
};

  const handleAddLine = () => {
    const currentLines = [...formData.calendarHolidayLines];

    if (currentLines.length > 0) {
      const lastLine = currentLines[currentLines.length - 1];
      if (!lastLine.CompanyID || !lastLine.HolidayID || !lastLine.FromDate) {
        toast.error("Please fill Current Row before adding new row");
        return;
      }
    }
    const newLineNo = currentLines.length + 1;

    currentLines.push({
      LineNo: newLineNo,
      HolidayID: "",
      FromDate: "",
      ToDate: "",
      Description: "",
    });
    setFormData({
      ...formData,
      calendarHolidayLines: currentLines,
    });
  };

  const handleDeleteLine = (index) => {
    const updatedLines = formData.calendarHolidayLines.filter(
      (_, i) => i !== index
    );
    setFormData({
      ...formData,
      calendarHolidayLines: updatedLines,
    });
  };

  const fetchCalenderDetails = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}calendarmaster`);
      setPageLoading(false);
      // Company List Option
      const company = response?.data?.companyList;
      const options = company.map((comp) => ({
        value: comp.value,
        label: comp.text,
      }));
      setCompanyList(options);
      // Payroll Method
      const payrol = response?.data?.payrollMethod;
      const payrolMethod = payrol.map((pay) => ({
        value: pay.value,
        label: pay.text,
      }));
      setPayrolMethod(payrolMethod);
      // Branch Option
      const branch = response?.data?.branches;
      const branchOption = branch.map((branch) => ({
        value: branch.value,
        label: branch.text,
      }));
      setBranchOpt(branchOption);
      // Holiday Option
      const holiday = response?.data?.holidayList;
      const HolidayOption = holiday.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setHolidayOpt(HolidayOption);
    } catch (error) {
      console.error("Error fetching JobType options:", error);
    }
  };

  useEffect(() => {
    fetchCalenderDetails();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationMessages = validateForm();

    if (validationMessages.length > 0) {
      validationMessages.forEach((msg) => toast.error(msg));
      return;
    }

    try {
      const response = await PostServiceCaller(
        `${API_URL}calendarmaster`,
        formData,
        "post"
      );

      if (response?.status === 200) {
        toast.success("Form submitted successfully!");
        navigate("/hrCalendar");
      }
    } catch (error) {
      console.error("There was an error posting the data!", error);
      toast.error("There was an error submitting the form!");
    }
  };
  const openDeleteModal = (type, item) => {
    setDeleteType(type);
    setSelectedDeleteItem(item);
    setShowDeleteModal(true);
  };
  const handleModalDelete = () => {
    if (selectedDeleteItem) {
      if (deleteType === "CalendarEdit") {
        handleDeleteLine(selectedDeleteItem.index);
      }
      setShowDeleteModal(false);
      setSelectedDeleteItem(null);
      setDeleteType("");
    }
  };
  const handleDeleteClose = () => {
    setShowDeleteModal(false);
    setSelectedDeleteItem(null);
    setDeleteType("");
  };
  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="container-fluid" id="skill_section">
          <div className="container-fluid" id="skill-table-area">
            <form onSubmit={handleSubmit}>
              {/* Tabs Section Start */}
              <ul className="nav nav-tabs overflow" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    style={{ color: "#2F2E4B" }}
                    id="calender-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#calender"
                    type="button"
                    role="tab"
                    aria-controls="calender"
                    aria-selected="true"
                  >
                    Calendar Details/Payroll Settings & Company Financial
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="holiday-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#holiday"
                    type="button"
                    role="tab"
                    aria-controls="holiday"
                    aria-selected="false"
                  >
                    Calendar Holidays
                  </button>
                </li>
              </ul>
              {/* Tabs Body Section  */}
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active mt-2"
                  id="calender"
                  role="tabpanel"
                  aria-labelledby="calender-tab"
                >
                  <div className="row mt-1">
                    <div className="col-md-3">
                      <label className="form-label">
                        Code <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.Code ? "is-invalid" : ""
                        }`}
                        name="Code"
                        onChange={handleChange}
                        value={formData.Code}
                      />
                      {errors.Code && (
                        <div className="error">Code is required</div>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">
                        Name <span className="text-danger">*</span>
                      </label>
                      <input
                        className={`form-control ${
                          errors.Name ? "is-invalid" : ""
                        }`}
                        name="Name"
                        onChange={handleChange}
                        value={formData.Name}
                      />
                      {errors.Name && (
                        <div className="error">Name is required</div>
                      )}
                    </div>

                    <div className="col-md-3">
                      <label className="form-label">
                        Company <span className="text-danger">*</span>
                      </label>
                      <Select
                        options={companyList}
                        name="CompanyID"
                        value={companyList.find(
                          (option) => option.value === formData.CompanyID
                        )}
                        onChange={(selectedOption) =>
                          handleInputChange("CompanyID", selectedOption)
                        }
                        className={errors.CompanyID ? "is-invalid" : ""}
                        classNamePrefix="select"
                      />

                      {errors.CompanyID && (
                        <div className="error" style={{ display: "block" }}>
                          Company is required
                        </div>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">
                        Payroll Method<span className="text-danger">*</span>
                      </label>
                      <Select
                        options={payrolMethod}
                        name="PayrollMethod"
                        onChange={(selectedOption) =>
                          handleInputChange("PayrollMethod", selectedOption)
                        }
                        className={errors.PayrollMethod ? "is-invalid" : ""}
                        classNamePrefix="select"
                      />
                      {errors.PayrollMethod && (
                        <div className="error" style={{ display: "block" }}>
                          Payroll Method is required
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-md-3">
                      <label className="form-label">
                        Fixed Payable Days
                      </label>
                      <input
                        className="form-control"
                        name="WorkingDays"
                        onChange={handleChange}
                        value={formData.WorkingDays}
                        disabled={formData.PayrollMethod !== 1018}
                      />
                      {/* {errors.WorkingDays && (
                        <div className="error">
                          Fixed Payable Days is required
                        </div>
                      )} */}
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Description</label>
                      <input
                        type="text"
                        className="form-control"
                        name="Description"
                        onChange={handleChange}
                        value={formData.Description}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">
                        Start Date<span className="text-danger">*</span>
                      </label>
                      <CustomDatePicker
                        name="StartDate"
                        handleChange={(e) => {
                          const date = e.target?.value
                            ? new Date(e.target.value)
                            : e;
                          handleStartDateChange(date);
                        }}
                        value={formData.StartDate}
                        placeholderText="Start Date"
                        className={`form-control ${
                          errors.StartDate ? "is-invalid" : ""
                        }`}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        dateFormat="dd-MMM-yyyy"
                      />
                      {errors.StartDate && (
                        <div className="error">Start Date is required</div>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">End Date</label>
                      <DatePicker
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        dateFormat="dd-MMM-yyyy"
                        className="form-control"
                        disabled
                        placeholderText="End Date"
                      />
                    </div>
                  </div>
                  {selectedDate && (
                    <div>
                      <h6 className="mt-2">
                        <b>Calendar Holiday </b>
                      </h6>
                      <Table striped bordered hover>
                        <thead id="thcolor" className="text-center">
                          <tr>
                            <th>Month Name</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th>Payable Days</th>
                          </tr>
                        </thead>
                        <tbody>
                          {calendarDetails.map((details, index) => (
                            <tr key={index}>
                              <td>{details.monthName}</td>
                              <td style={{ textAlign: "center" }}>
                                {details.monthStartDate
                                  ? moment(details.monthStartDate).format(
                                      "DD-MMM-YYYY"
                                    )
                                  : ""}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {details.monthEndDate}
                              </td>
                              <td className="text-center">
                                {details.monthDays || ""}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  )}
                </div>
                <div
                  className="tab-pane fade show mt-2"
                  id="holiday"
                  role="tabpanel"
                  aria-labelledby="holiday-tab"
                >
                  <div className="row">
                    <div className="text-end my-1">
                      <button
                        type="button"
                        onClick={handleAddLine}
                        className="custom-btn-sm pull-right"
                        disabled={isAddDisabled}
                        style={{
                          opacity: isAddDisabled ? 0.5 : 1,
                          cursor: isAddDisabled ? "not-allowed" : "pointer",
                        }}
                      >
                        <i className="fa fa-plus"></i>&nbsp;Add
                      </button>
                    </div>
                    <div className="col-md-12">
                      <div className="table-responsive poc-head rounded">
                        <table
                          id="poctable_head"
                          className="table table-bordered"
                        >
                          <thead id="thcolor" className="text-center">
                            <tr>
                              <th>Sr. No.</th>
                              <th>
                                Branch <span className="text-danger">*</span>
                              </th>
                              <th>
                                Holiday <span className="text-danger">*</span>
                              </th>
                              <th>
                                From Date <span className="text-danger">*</span>
                              </th>
                              <th>To Date</th>
                              <th>Description</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {formData?.calendarHolidayLines?.map(
                              (line, index) => {
                                const lineError =
                                  holidayLineErrors[index] || {};
                                return (
                                  <tr key={index} className="bg-white">
                                    <td>{index + 1}</td>
                                    <td>
                                      <Select
                                        options={branchOpt}
                                        name="CompanyID"
                                        onChange={(selectedOption) =>
                                          handleSelectChange(
                                            selectedOption,
                                            "CompanyID",
                                            index
                                          )
                                        }
                                        value={branchOpt.find(
                                          (opt) => opt.value === line.CompanyID
                                        )}
                                        menuPortalTarget={document.body}
                                        styles={{
                                          menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 9999,
                                          }),
                                          control: (base) => ({
                                            ...base,
                                            borderColor: lineError.CompanyID
                                              ? "#dc3545"
                                              : "#ced4da",
                                          }),
                                        }}
                                        className={
                                          lineError.CompanyID
                                            ? "is-invalid"
                                            : ""
                                        }
                                        menuPlacement="top"
                                      />
                                      {lineError.CompanyID && (
                                        <div className="error d-block">
                                          Branch is required
                                        </div>
                                      )}
                                    </td>
                                    <td>
                                      <Select
                                        options={holidayOpt}
                                        name="HolidayID"
                                        onChange={(selectedOption) =>
                                          handleSelectChange(
                                            selectedOption,
                                            "HolidayID",
                                            index
                                          )
                                        }
                                        value={holidayOpt.find(
                                          (opt) => opt.value === line.HolidayID
                                        )}
                                        menuPortalTarget={document.body}
                                        styles={{
                                          menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 9999,
                                          }),
                                          control: (base) => ({
                                            ...base,
                                            borderColor: lineError.HolidayID
                                              ? "#dc3545"
                                              : "#ced4da",
                                          }),
                                        }}
                                        className={
                                          lineError.HolidayID
                                            ? "is-invalid"
                                            : ""
                                        }
                                        menuPlacement="top"
                                      />
                                      {lineError.HolidayID && (
                                        <div className="error d-block">
                                          Holiday is required
                                        </div>
                                      )}
                                    </td>
                                    <td>
                                      <CustomDatePicker
                                        name="FromDate"
                                        handleChange={(e) =>
                                          handleResDateChange(e, index)
                                        }
                                        value={line.FromDate}
                                        placeholderText="From Date"
                                        className={`form-control ${
                                          lineError.FromDate ? "is-invalid" : ""
                                        }`}
                                      />
                                      {lineError.FromDate && (
                                        <div className="error d-block">
                                          From Date is required
                                        </div>
                                      )}
                                    </td>
                                    <td>
                                      <CustomDatePicker
                                        name="ToDate"
                                        handleChange={(e) =>
                                          handleResDateChange(e, index)
                                        }
                                        value={line.ToDate}
                                        placeholderText="To Date"
                                        className="form-control"
                                      />
                                    </td>
                                    <td>
                                      <textarea
                                        type="text"
                                        name="Description"
                                        value={line.Description}
                                        className="form-control"
                                        onChange={(e) =>
                                          handleLineChange(e, index)
                                        }
                                      ></textarea>
                                    </td>
                                    <td>
                                      <div
                                        // onClick={() => handleDeleteLine(index)}
                                        onClick={() =>
                                          openDeleteModal("CalendarEdit", {
                                            index,
                                          })
                                        }
                                        className="text-center mt-3"
                                      >
                                        <i
                                          className="bi bi-trash"
                                          style={{ fontSize: "1.2rem" }}
                                        ></i>
                                      </div>
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-end me-2 mt-2">
                <button
                  type="button"
                  className="cancel-btn me-2"
                  onClick={() => {
                    navigate("/hrCalendar");
                  }}
                >
                  Cancel
                </button>
                <button type="submit" className="custom-btn me-2">
                  Submit
                </button>
              </div>
            </form>
          </div>
          <DeleteModal
            show={showDeleteModal}
            onClose={handleDeleteClose}
            onConfirm={handleModalDelete}
            message="Are you sure you want to delete this item?"
          />
        </div>
      </>
    );
  }
};

export default HRCalenderForm;
